// "use client"

// import { useState, useEffect } from "react"
// import { Link, useNavigate } from "react-router-dom"
// import axios from "axios"
// import { toast } from "react-toastify"
// import { baseUrl } from "../../config/baseUrl"
// import Swal from "sweetalert2"
// // import { hasPermission, PERMISSIONS } from "../../utils/permissions"

// export default function AdminUserList() {
//   const navigate = useNavigate()
//   const [users, setUsers] = useState([])
//   const [loading, setLoading] = useState(true)
//   const [deleteLoading, setDeleteLoading] = useState(null)
//   const [searchTerm, setSearchTerm] = useState("")

//   // const canCreate = hasPermission(PERMISSIONS.USER_CREATE)
//   // const canEdit = hasPermission(PERMISSIONS.USER_EDIT)
//   // const canDelete = hasPermission(PERMISSIONS.USER_DELETE)

//   useEffect(() => {
//     // if (!hasPermission(PERMISSIONS.USER_VIEW)) {
//     //     toast.error("You do not have permission to view users")
//     //     navigate("/")
//     //     return
//     // }
//     fetchUsers()
//   }, [])

//   const fetchUsers = async () => {
//     try {
//       setLoading(true)
//       const token = localStorage.getItem("token")
//       const response = await axios.get(`${baseUrl}/admin-user/admin-user-list`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       })

//       if (response.data.status) {
//         setUsers(response.data.data || [])
//       }
//     } catch (error) {
//       console.error("Error fetching users:", error)
//       toast.error("Failed to fetch users")
//     } finally {
//       setLoading(false)
//     }
//   }

//   const handleDelete = async (id) => {
//     // if (!canDelete) {
//     //   toast.error("You do not have permission to delete users")
//     //   return
//     // }
//     Swal.fire({
//       title: "Are you sure?",
//       text: "You won't be able to revert this!",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#3085d6",
//       cancelButtonColor: "#d33",
//       confirmButtonText: "Yes, delete it!",
//     }).then(async (result) => {
//       if (result.isConfirmed) {
//         try {
//           setDeleteLoading(id)
//           const token = localStorage.getItem("token")
//           const response = await axios.delete(
//             `${baseUrl}/admin-user/admin-user-delete/${id}`,
//             {
//               headers: {
//                 Authorization: `Bearer ${token}`,
//               },
//             }
//           )

//           if (response.data.status) {
//             toast.success("User deleted successfully")
//             fetchUsers()
//           }
//         } catch (error) {
//           console.error("Error deleting user:", error)
//           toast.error("Failed to delete user")
//         } finally {
//           setDeleteLoading(null)
//         }
//       }
//     })
//   }


//   const filteredUsers = users.filter(
//     (user) =>
//       user.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       user.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       user.phone?.includes(searchTerm),
//   )

//   return (
//     <div className=" main-sec">
//       <div className="page-header">
//         <div>
//           <h2 className="page-title">Admin User Management</h2>
//           <p className="page-subtitle">Manage admin users and their roles</p>
//         </div>

//         <Link to="/admin-users/create" className="btn-primary-custom">
//           <i className="fa fa-user-plus me-2"></i>
//           Add User
//         </Link>

//       </div>

//       <div className="filter-section">
//         <div className="search-box">
//           <i className="fa fa-search search-icon"></i>
//           <input
//             type="text"
//             placeholder="Search by name, email or mobile..."
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             className="search-input"
//           />
//         </div>
//       </div>

//       {loading ? (
//         <div className="loading-container">
//           <div className="spinner"></div>
//           <p>Loading users...</p>
//         </div>
//       ) : (
//         <div className="table-container">
//           {filteredUsers.length === 0 ? (
//             <div className="empty-state">
//               <i className="fa fa-users empty-icon"></i>
//               <h3>No users found</h3>
//               <p>Add your first admin user to get started</p>
//             </div>
//           ) : (
//             <table className="data-table">
//               <thead>
//                 <tr>
//                   <th>Name</th>
//                   <th>Email</th>
//                   <th>Mobile</th>
//                   <th>Role</th>
//                   <th>Status</th>
//                   <th>Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {filteredUsers.map((user) => (
//                   <tr key={user._id}>
//                     <td>
//                       <div className="user-info">
//                         <div className="user-avatar">{user.name?.charAt(0).toUpperCase() || "U"}</div>
//                         <span className="user-name">{user.name || "N/A"}</span>
//                       </div>
//                     </td>
//                     <td>{user.email || "N/A"}</td>
//                     <td>{user.phone || "N/A"}</td>
//                     <td>
//                       <span className="role-badge">{user.role?.name || "No Role"}</span>
//                     </td>
//                     <td>
//                       <span className={`status-badge ${user.status === "active" ? "active" : "inactive"}`}>
//                         {user.status === "active" ? "Active" : "Inactive"}
//                       </span>
//                     </td>
//                     <td>
//                       <div className="action-buttons">

//                         <button
//                           onClick={() => navigate(`/admin-users/edit/${user._id}`)}
//                           className="btn-icon btn-edit"
//                           title="Edit User"
//                         >
//                           <i className="fa fa-edit"></i>
//                         </button>


//                         <button
//                           onClick={() => handleDelete(user._id)}
//                           className="btn-icon btn-delete"
//                           disabled={deleteLoading === user._id}
//                           title="Delete User"
//                         >
//                           {deleteLoading === user._id ? (
//                             <div className="btn-spinner"></div>
//                           ) : (
//                             <i className="fa fa-trash"></i>
//                           )}
//                         </button>

//                       </div>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           )}
//         </div>
//       )}

//       <style jsx>{`
//         .user-list-container {
//           padding: 24px;
//           max-width: 1400px;
//           margin: 0 auto;
//         }

//         .page-header {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           margin-bottom: 32px;
//           flex-wrap: wrap;
//           gap: 16px;
//         }

//         .page-title {
//           font-size: 28px;
//           font-weight: 600;
//           color: #1e293b;
//           margin: 0;
//         }

//         .page-subtitle {
//           color: #64748b;
//           font-size: 14px;
//           margin: 4px 0 0 0;
//         }

//         .btn-primary-custom {
//           display: inline-flex;
//           align-items: center;
//           padding: 10px 20px;
//           background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%);
//           color: white;
//           border: none;
//           border-radius: 8px;
//           font-weight: 500;
//           text-decoration: none;
//           transition: all 0.3s ease;
//           box-shadow: 0 2px 8px rgba(99, 102, 241, 0.2);
//         }

//         .btn-primary-custom:hover {
//           transform: translateY(-2px);
//           box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3);
//           color: white;
//         }

//         .filter-section {
//           margin-bottom: 24px;
//         }

//         .search-box {
//           position: relative;
//           max-width: 400px;
//         }

//         .search-icon {
//           position: absolute;
//           left: 16px;
//           top: 50%;
//           transform: translateY(-50%);
//           color: #94a3b8;
//         }

//         .search-input {
//           width: 100%;
//           padding: 12px 16px 12px 44px;
//           border: 1px solid #e2e8f0;
//           border-radius: 8px;
//           font-size: 14px;
//           transition: all 0.3s ease;
//           background: white;
//         }

//         .search-input:focus {
//           outline: none;
//           border-color: #6366f1;
//           box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
//         }

//         .loading-container {
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           justify-content: center;
//           padding: 60px 20px;
//           color: #64748b;
//         }

//         .spinner {
//           width: 48px;
//           height: 48px;
//           border: 4px solid #e2e8f0;
//           border-top-color: #6366f1;
//           border-radius: 50%;
//           animation: spin 0.8s linear infinite;
//           margin-bottom: 16px;
//         }

//         @keyframes spin {
//           to { transform: rotate(360deg); }
//         }

//         .table-container {
//           background: white;
//           border: 1px solid #e2e8f0;
//           border-radius: 12px;
//           overflow: hidden;
//         }

//         .data-table {
//           width: 100%;
//           border-collapse: collapse;
//         }

//         .data-table thead {
//           background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
//         }

//         .data-table th {
//           padding: 16px 20px;
//           text-align: left;
//           font-weight: 600;
//           font-size: 13px;
//           color: #475569;
//           text-transform: uppercase;
//           letter-spacing: 0.5px;
//           border-bottom: 1px solid #e2e8f0;
//         }

//         .data-table td {
//           padding: 16px 20px;
//           border-bottom: 1px solid #f1f5f9;
//           color: #334155;
//           font-size: 14px;
//         }

//         .data-table tbody tr:hover {
//           background: #f8fafc;
//         }

//         .user-info {
//           display: flex;
//           align-items: center;
//           gap: 12px;
//         }

//         .user-avatar {
//           width: 40px;
//           height: 40px;
//           background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%);
//           color: white;
//           border-radius: 10px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           font-weight: 600;
//           font-size: 16px;
//         }

//         .user-name {
//           font-weight: 500;
//           color: #1e293b;
//         }

//         .role-badge {
//           display: inline-block;
//           padding: 6px 12px;
//           background: #ede9fe;
//           color: #6366f1;
//           border-radius: 6px;
//           font-size: 12px;
//           font-weight: 500;
//         }

//         .status-badge {
//           display: inline-block;
//           padding: 6px 12px;
//           border-radius: 6px;
//           font-size: 12px;
//           font-weight: 500;
//         }

//         .status-badge.active {
//           background: #d1fae5;
//           color: #059669;
//         }

//         .status-badge.inactive {
//           background: #fee2e2;
//           color: #dc2626;
//         }

//         .action-buttons {
//           display: flex;
//           gap: 8px;
//         }

//         .btn-icon {
//           width: 36px;
//           height: 36px;
//           border: none;
//           border-radius: 6px;
//           cursor: pointer;
//           transition: all 0.3s ease;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//         }

//         .btn-edit {
//           background: #f0fdf4;
//           color: #16a34a;
//         }

//         .btn-edit:hover {
//           background: #dcfce7;
//         }

//         .btn-delete {
//           background: #fef2f2;
//           color: #dc2626;
//         }

//         .btn-delete:hover:not(:disabled) {
//           background: #fee2e2;
//         }

//         .btn-delete:disabled {
//           opacity: 0.6;
//           cursor: not-allowed;
//         }

//         .btn-spinner {
//           width: 14px;
//           height: 14px;
//           border: 2px solid #fca5a5;
//           border-top-color: #dc2626;
//           border-radius: 50%;
//           animation: spin 0.6s linear infinite;
//         }

//         .empty-state {
//           text-align: center;
//           padding: 60px 20px;
//         }

//         .empty-icon {
//           font-size: 64px;
//           color: #cbd5e1;
//           margin-bottom: 16px;
//         }

//         .empty-state h3 {
//           font-size: 20px;
//           font-weight: 600;
//           color: #475569;
//           margin: 0 0 8px 0;
//         }

//         .empty-state p {
//           color: #94a3b8;
//           margin: 0;
//         }

//         @media (max-width: 968px) {
//           .table-container {
//             overflow-x: auto;
//           }

//           .data-table {
//             min-width: 800px;
//           }
//         }

//         @media (max-width: 768px) {
//           .page-header {
//             flex-direction: column;
//             align-items: flex-start;
//           }
//         }
//       `}</style>
//     </div>
//   )
// }


"use client"

import { useState, useEffect } from "react"
import { Link, useNavigate } from "react-router-dom"
import axios from "axios"
import { toast } from "react-toastify"
import { baseUrl } from "../../config/baseUrl"
import Swal from "sweetalert2"
import PermissionGuard from "../../Component/PermissionGuard/PermissionGuard"
import { PERMISSIONS } from "../../utils/permissions"

export default function AdminUserList() {
  const navigate = useNavigate()
  const [users, setUsers] = useState([])
  const [loading, setLoading] = useState(true)
  const [deleteLoading, setDeleteLoading] = useState(null)
  const [searchTerm, setSearchTerm] = useState("")

  useEffect(() => {
    fetchUsers()
  }, [])

  const fetchUsers = async () => {
    try {
      setLoading(true)
      const token = localStorage.getItem("token")
      const response = await axios.get(`${baseUrl}/admin-user/admin-user-list`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })

      if (response.data.status) {
        setUsers(response.data.data || [])
      }
    } catch (error) {
      console.error("Error fetching users:", error)
      toast.error("Failed to fetch users")
    } finally {
      setLoading(false)
    }
  }

  const handleDelete = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setDeleteLoading(id)
          const token = localStorage.getItem("token")
          const response = await axios.delete(`${baseUrl}/admin-user/admin-user-delete/${id}`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })

          if (response.data.status) {
            toast.success("User deleted successfully")
            fetchUsers()
          }
        } catch (error) {
          console.error("Error deleting user:", error)
          toast.error("Failed to delete user")
        } finally {
          setDeleteLoading(null)
        }
      }
    })
  }

  const filteredUsers = users.filter(
    (user) =>
      user.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.phone?.includes(searchTerm),
  )

  return (
    <div className=" main-sec">
      <div className="page-header">
        <div>
          <h2 className="page-title">Admin User Management</h2>
          <p className="page-subtitle">Manage admin users and their roles</p>
        </div>

        <PermissionGuard permission={PERMISSIONS.USER_CREATE}>
          <Link to="/admin-users/create" className="btn-primary-custom">
            <i className="fa fa-user-plus me-2"></i>
            Add User
          </Link>
        </PermissionGuard>
      </div>

      <div className="filter-section">
        <div className="search-box">
          <i className="fa fa-search search-icon"></i>
          <input
            type="text"
            placeholder="Search by name, email or mobile..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
        </div>
      </div>

      {loading ? (
        <div className="loading-container">
          <div className="spinner"></div>
          <p>Loading users...</p>
        </div>
      ) : (
        <div className="table-container">
          {filteredUsers.length === 0 ? (
            <div className="empty-state">
              <i className="fa fa-users empty-icon"></i>
              <h3>No users found</h3>
              <p>Add your first admin user to get started</p>
            </div>
          ) : (
            <table className="data-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Mobile</th>
                  <th>Role</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredUsers.map((user) => (
                  <tr key={user._id}>
                    <td>
                      <div className="user-info">
                        <div className="user-avatar">{user.name?.charAt(0).toUpperCase() || "U"}</div>
                        <span className="user-name">{user.name || "N/A"}</span>
                      </div>
                    </td>
                    <td>{user.email || "N/A"}</td>
                    <td>{user.phone || "N/A"}</td>
                    <td>
                      <span className="role-badge">{user.role?.name || "No Role"}</span>
                    </td>
                    <td>
                      <span className={`status-badge ${user.status === "active" ? "active" : "inactive"}`}>
                        {user.status === "active" ? "Active" : "Inactive"}
                      </span>
                    </td>
                    <td>
                      <div className="action-buttons">
                        <PermissionGuard permission={PERMISSIONS.USER_EDIT}>
                          <button
                            onClick={() => navigate(`/admin-users/edit/${user._id}`)}
                            className="btn-icon btn-edit"
                            title="Edit User"
                          >
                            <i className="fa fa-edit"></i>
                          </button>
                        </PermissionGuard>

                        <PermissionGuard permission={PERMISSIONS.USER_DELETE}>
                          <button
                            onClick={() => handleDelete(user._id)}
                            className="btn-icon btn-delete"
                            disabled={deleteLoading === user._id}
                            title="Delete User"
                          >
                            {deleteLoading === user._id ? (
                              <div className="btn-spinner"></div>
                            ) : (
                              <i className="fa fa-trash"></i>
                            )}
                          </button>
                        </PermissionGuard>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}

      <style jsx>{`
        .user-list-container {
          padding: 24px;
          max-width: 1400px;
          margin: 0 auto;
        }

        .page-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 32px;
          flex-wrap: wrap;
          gap: 16px;
        }

        .page-title {
          font-size: 28px;
          font-weight: 600;
          color: #1e293b;
          margin: 0;
        }

        .page-subtitle {
          color: #64748b;
          font-size: 14px;
          margin: 4px 0 0 0;
        }

        .btn-primary-custom {
          display: inline-flex;
          align-items: center;
          padding: 10px 20px;
          background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%);
          color: white;
          border: none;
          border-radius: 8px;
          font-weight: 500;
          text-decoration: none;
          transition: all 0.3s ease;
          box-shadow: 0 2px 8px rgba(99, 102, 241, 0.2);
        }

        .btn-primary-custom:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3);
          color: white;
        }

        .filter-section {
          margin-bottom: 24px;
        }

        .search-box {
          position: relative;
          max-width: 400px;
        }

        .search-icon {
          position: absolute;
          left: 16px;
          top: 50%;
          transform: translateY(-50%);
          color: #94a3b8;
        }

        .search-input {
          width: 100%;
          padding: 12px 16px 12px 44px;
          border: 1px solid #e2e8f0;
          border-radius: 8px;
          font-size: 14px;
          transition: all 0.3s ease;
          background: white;
        }

        .search-input:focus {
          outline: none;
          border-color: #6366f1;
          box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
        }

        .loading-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 60px 20px;
          color: #64748b;
        }

        .spinner {
          width: 48px;
          height: 48px;
          border: 4px solid #e2e8f0;
          border-top-color: #6366f1;
          border-radius: 50%;
          animation: spin 0.8s linear infinite;
          margin-bottom: 16px;
        }

        @keyframes spin {
          to { transform: rotate(360deg); }
        }

        .table-container {
          background: white;
          border: 1px solid #e2e8f0;
          border-radius: 12px;
          overflow: hidden;
        }

        .data-table {
          width: 100%;
          border-collapse: collapse;
        }

        .data-table thead {
          background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
        }

        .data-table th {
          padding: 16px 20px;
          text-align: left;
          font-weight: 600;
          font-size: 13px;
          color: #475569;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          border-bottom: 1px solid #e2e8f0;
        }

        .data-table td {
          padding: 16px 20px;
          border-bottom: 1px solid #f1f5f9;
          color: #334155;
          font-size: 14px;
        }

        .data-table tbody tr:hover {
          background: #f8fafc;
        }

        .user-info {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .user-avatar {
          width: 40px;
          height: 40px;
          background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%);
          color: white;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 600;
          font-size: 16px;
        }

        .user-name {
          font-weight: 500;
          color: #1e293b;
        }

        .role-badge {
          display: inline-block;
          padding: 6px 12px;
          background: #ede9fe;
          color: #6366f1;
          border-radius: 6px;
          font-size: 12px;
          font-weight: 500;
        }

        .status-badge {
          display: inline-block;
          padding: 6px 12px;
          border-radius: 6px;
          font-size: 12px;
          font-weight: 500;
        }

        .status-badge.active {
          background: #d1fae5;
          color: #059669;
        }

        .status-badge.inactive {
          background: #fee2e2;
          color: #dc2626;
        }

        .action-buttons {
          display: flex;
          gap: 8px;
        }

        .btn-icon {
          width: 36px;
          height: 36px;
          border: none;
          border-radius: 6px;
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .btn-edit {
          background: #f0fdf4;
          color: #16a34a;
        }

        .btn-edit:hover {
          background: #dcfce7;
        }

        .btn-delete {
          background: #fef2f2;
          color: #dc2626;
        }

        .btn-delete:hover:not(:disabled) {
          background: #fee2e2;
        }

        .btn-delete:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        .btn-spinner {
          width: 14px;
          height: 14px;
          border: 2px solid #fca5a5;
          border-top-color: #dc2626;
          border-radius: 50%;
          animation: spin 0.6s linear infinite;
        }

        .empty-state {
          text-align: center;
          padding: 60px 20px;
        }

        .empty-icon {
          font-size: 64px;
          color: #cbd5e1;
          margin-bottom: 16px;
        }

        .empty-state h3 {
          font-size: 20px;
          font-weight: 600;
          color: #475569;
          margin: 0 0 8px 0;
        }

        .empty-state p {
          color: #94a3b8;
          margin: 0;
        }

        @media (max-width: 968px) {
          .table-container {
            overflow-x: auto;
          }

          .data-table {
            min-width: 800px;
          }
        }

        @media (max-width: 768px) {
          .page-header {
            flex-direction: column;
            align-items: flex-start;
          }
        }
      `}</style>
    </div>
  )
}
